













import { Component, Prop, Watch } from "vue-property-decorator";
import {
  ContaCorrenteParceiro,
  ContaCorrenteParceirosService,
} from "@/services/conta-corrente-parceiros.service";
import { mixins } from "vue-class-component";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { moeda, dateTime } from "@/shared/filters";
@Component({ filters: { dateTime, moeda } })
export default class ContaCorrenteParceiros extends mixins(GlobalMixin) {
  @Prop() idContaCorrenteParceiro!: string;
  ccParceiro: ContaCorrenteParceiro | null = null;
  loading = false;
  mounted() {
    this.fetchHistoricos();
  }
  async fetchHistoricos() {
    this.startLoader();
    this.ccParceiro = await ContaCorrenteParceirosService.obterCompleto(
      this.idContaCorrenteParceiro
    ).finally(this.stopLoader);
  }
  @Watch("idContaCorrenteParceiro")
  changeProduto() {
    this.fetchHistoricos();
  }
}
